import JoursFeriesController from './jours.feries.controller';

export default {
    template: require('./jours.feries.tpl.html'),
    controller: JoursFeriesController
};
